module.exports = __webpack_public_path__ + "img/didocu1.1a0a5030.png";